import { Component, OnInit, ViewEncapsulation, ViewChild } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { fuseAnimations } from '@fuse/animations';
import { merge } from 'rxjs';
import { MediaObserver, MediaChange } from '@angular/flex-layout';
import { MatPaginator } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { PropertiesService } from 'app/services/properties.service';
import { startWith, tap, switchMap, filter, map } from 'rxjs/operators';
import { FuseConfirmDialogComponent } from '@fuse/components/confirm-dialog/confirm-dialog.component';
import { Router } from '@angular/router';
import { PropertiesPrintEmailComponent } from '../../properties-print-email/properties-print-email.component';
@Component({
  selector: 'private-basket',
  templateUrl: './private-basket.component.html',
  styleUrls: ['./private-basket.component.scss'],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None
})
export class PrivateBasketComponent implements OnInit {

  loadingResults = false;
  displayedColumns: string[] = ['reference', 'type_one_name', 'location_name', 'currentprice', 'bedrooms', 'action'];
  dataReload: UntypedFormControl = new UntypedFormControl(null);
  properties: any = {
    data: []
  };
  filter: any = {};
  searchDialogRef: any;
  confirmDialogRef: MatDialogRef<FuseConfirmDialogComponent>;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  constructor(
    private mediaObserver: MediaObserver,
    public matDialogRef: MatDialogRef<PrivateBasketComponent>,
    private _translateService: TranslateService,
    private _propertiesService: PropertiesService,
    private router: Router,
    private _matDialog: MatDialog
  ) {
 
  }

  ngOnInit(): void {

    this.mediaObserver.asObservable()
      .pipe(
        filter((changes: MediaChange[]) => changes.length > 0),
        map((changes: MediaChange[]) => changes[0])
      )
      .subscribe((change: MediaChange) => {
        if (this.mediaObserver.isActive('xs') || this.mediaObserver.isActive('sm')) {
          this.displayedColumns = ['reference', 'type_one_name', 'action'];
        } else if (this.mediaObserver.isActive('md') || this.mediaObserver.isActive('lt-md')) {
          this.displayedColumns = ['reference', 'type_one_name', 'location_name', 'action'];
        } else {
          this.displayedColumns = ['reference', 'type_one_name', 'location_name', 'currentprice', 'bedrooms', 'action'];
        }
      });
    merge(this.paginator.page,
      this.dataReload.valueChanges)
      .pipe(
        startWith(''),
        tap(() => this.loadingResults = true),
        switchMap(() => {
          if (this.dataReload.value === 'refresh') {
            this.filter = { grid: false, status_not: 'inactive' };
            this.paginator.pageIndex = 0;
          }
          this.dataReload.setValue(null, { emitEvent: false });
          return this._propertiesService.getPrivateBasketList(this.filter, this.paginator.pageIndex + 1);
        })
      )
      .subscribe((data: any) => {
        this.loadingResults = false;
        this.properties.data = data.body;
        this.properties.total = data.headers.get('x-pagination-total-count');
        this.properties.limit = data.headers.get('x-pagination-per-page');
      }, () => this.loadingResults = false);
  }
  ViewProperty(id: any): void {
    this.router.navigateByUrl('/properties/view/' + id);
    this.matDialogRef.close();
  }
  EditProperty(id: any): void {
      this.router.navigateByUrl('/properties/update/' + id);
      this.matDialogRef.close();
  }
  navigate(): void {
    this._matDialog.open(PropertiesPrintEmailComponent, {
      panelClass: 'pdf-dialog',
      data: {
        selectedItems: this.properties.data.map(item => item._id)
       },
      disableClose: true
    });
    // this.router.navigate(['/properties/print-pdf'], { state: { data: this.properties.data.map(item => item._id) } });
    this.matDialogRef.close();
  }
  clearList(): void {
    this._propertiesService.clearBaskets()
    .pipe(
      tap(() => this.loadingResults = true)
    )
    .subscribe(() => {
      this.loadingResults = false;
      this.dataReload.setValue('refresh', {emitEvent: true});
    }, () => this.loadingResults = false);
  }

}
  





